import React from "react";
import ActionItem from "../components/ActionItem";
import { EndPageText } from "../components/EndPageText";
import Header from "../components/Header";
import LayoutContent from "../components/LayoutContent";

const EndPage = ({ teamAction, deleteTeamAction, updateTeamAction }) => {
  return (
    <LayoutContent>
      <Header visibility={"hidden"} />
      <div className="endpage">
        <EndPageText />
        <ActionItem
          teamAction={teamAction}
          deleteTeamAction={deleteTeamAction}
          updateTeamAction={updateTeamAction}
        />
      </div>
    </LayoutContent>
  );
};

export default EndPage;
